import { PublicKey } from "@solana/web3.js";

/**
 * Format a wallet address to show first 4 and last 4 characters
 * Example: 8PeLmNzqyAzqy... -> 8PeL...Azqy
 */
export const formatWalletAddress = (address: string | PublicKey): string => {
  const addressStr = typeof address === "string" ? address : address.toString();
  
  if (addressStr.length <= 8) {
    return addressStr;
  }
  
  return `${addressStr.slice(0, 4)}...${addressStr.slice(-4)}`;
};

